import omit from 'lodash.omit';
export const IconColor = {
  PRIMARY_CONTRAST: 'primary_contrast',
  SECONDARY_CONTRAST: 'secondary_contrast',
  NEGATIVE_CONTRAST: 'negative_contrast',
  POSITIVE_CONTRAST: 'positive_contrast',
  ATTENTION_CONTRAST: 'attention_contrast',
  LIGHT: 'light',
  DARK: 'dark',
  MONO_100: 'mono_100',
  MONO_600: 'mono_600',
  MONO_500: 'mono_500',
  MONO_900: 'mono_900'
};
export const IconSize = {
  EXTRA_SMALL: 8,
  SMALL: 16,
  NORMAL: 24,
  LARGE: 32,
  EXTRA_LARGE: 48,
  EXTRA_EXTRA_LARGE: 72
};
export const IconGeneratedAssetSize = omit(IconSize, 'EXTRA_SMALL', 'EXTRA_EXTRA_LARGE');
export const IconType = {
  REGULAR: 'Regular',
  COLOR: 'Color',
  TYPE_30: '30'
};
export const DEFAULT_ICON_SIZE = IconSize.NORMAL;
export const EXAMPLE_ICON_NAME = 'ChevronRight';